import Button from 'assets/components/button/Button';
import ThemeButtonMenuItem from 'assets/components/button/themes/Theme.Button.MenuItem';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import useUIEditor from 'assets/hooks/uiEditor/UIEditor';
import { getLocales } from 'assets/locales/Locale';
import DropdownButton from 'assets/templates/dropdownButton/DropdownButton';
import ThemeDropdownButtonPopup from 'assets/templates/dropdownButton/themes/Theme.DropdownButton.Popup';
import { UICommand } from 'assets/utils/dom/Commands';

/**
 * Only these six prefixes resolve for contract refund invoices. A valid prefix with a misspelled
 * property throws a 500 at send time rather than rendering blank, which is why placeholders are
 * offered as a fixed insert list instead of free text.
 *
 * Deliberately absent (the payment template has them, this one does not): Client, Vehicle,
 * LedgerAccount and IPayee all render empty here.
 */
export default function ContractRefundInvoiceEmailTemplateTags() {
  const { lang } = getLocales();
  const uiEditor = useUIEditor();
  return (
    <DropdownButton
      buttonMedia={<Icon class="fas-plus" />}
      buttonBody={lang.addPlaceholder}
      horizontalPosition="auto_fixed"
      verticalPosition="auto_fixed"
      tabIndex={null}
      htmlElementProps={{
        title: lang.addEmailTemplatePlaceholder,
      }}
      subcomponents={ThemeDropdownButtonPopup}
      dropdownOptions={
        <DataMap
          data={[
            // Pre-formatted for display - prefer these over the raw ContractRefundInvoice_ values.
            { id: '{{ContractRefundInvoiceDetail_TotalAmount}}', title: `${lang.total}` },
            { id: '{{ContractRefundInvoiceDetail_InvoiceDate}}', title: `${lang.invoiceDate}` },
            { id: '{{ContractRefundInvoiceDetail_RefundJobId}}', title: `${lang.refund} #` },
            { id: '{{ContractRefundInvoiceDetail_AppNumber}}', title: lang.appNumber },

            { id: '{{ContractRefundInvoice_Number}}', title: lang.invoiceNumber },
            { id: '{{ContractRefundInvoice_TotalAmount}}', title: lang.total },
            { id: '{{ContractRefundInvoice_TotalAmountBeforeTax}}', title: lang.amount },
            { id: '{{ContractRefundInvoice_GstHstAmount}}', title: lang.gstHst },
            { id: '{{ContractRefundInvoice_ProvincialSalesTaxAmount}}', title: lang.pst },
            { id: '{{ContractRefundInvoice_Currency}}', title: lang.currency },
            { id: '{{ContractRefundInvoice_PaymentMethodCode}}', title: lang.paymentMethod },
            { id: '{{ContractRefundInvoice_IsCancelled}}', title: lang.cancelled },
            { id: '{{ContractRefundInvoice_CreatedAtLocal}}', title: lang.createdAtLocal },
            { id: '{{ContractRefundInvoice_CreatedAtUtc}}', title: `${lang.createdAt}` },
            { id: '{{ContractRefundInvoice_PaymentRequestedAtUtc}}', title: lang.paymentRequestedAt },

            { id: '{{ContractRefund_JobId}}', title: `${lang.contractRefund} ${lang.jobNumber}` },
            { id: '{{ContractRefund_NewAppNumber}}', title: lang.newAppNumber },
            { id: '{{ContractRefund_StatusCode}}', title: lang.status },

            { id: '{{Contract_AppNumber}}', title: `${lang.contract} ${lang.appNumber}` },

            { id: '{{Dealer_Name}}', title: lang.dealerName },
            { id: '{{Dealer_StreetAddress}}', title: lang.streetAddress },
            { id: '{{Dealer_City}}', title: lang.city },
            { id: '{{Dealer_ProvinceCode}}', title: lang.province },
            { id: '{{Dealer_PostalCode}}', title: lang.postalCode },
            { id: '{{Dealer_CountryCode}}', title: lang.countryCode },

            { id: '{{IEmailTemplate_SenderName}}', title: lang.senderName },
            { id: '{{IEmailTemplate_Name}}', title: lang.name },
            { id: '{{IEmailTemplate_Subject}}', title: lang.subject },
          ]}
          render={({ data }) => (
            <Button
              key={data.id}
              class={ThemeButtonMenuItem}
              render={data.title}
              onClick={(data) => uiEditor.applyUiCommand(UICommand.insertHTML, data)}
              data={data.id}
            />
          )}
        />
      }
    />
  );
}
